import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { AttachmentType } from "../../../enums";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { CarriersService } from "../../../services/carriers.service";
import { LookupService } from "../../../services/lookup.service";
import { RequestsService } from "../../../services/requests.service";
import { CarrierCompanyTrackModel } from "./carrier-company-track.model";
import { UploadAttachmentsModel, UploadFile } from "../../../models/attachment";
import { AttachmentsService } from "../../../services/attachments.service";
import { HttpResponse } from "@angular/common/http";
import { forkJoin } from "rxjs";


@Component({
	selector: 'set-carrier',
	templateUrl: './set-carrier.html',
	styleUrls: ['./set-carrier.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})

export class SetCarrier implements OnInit {
	
	@Input() activityId: number
	@Input() requestId: number;

	@Output() onContinueEvent: EventEmitter<any> = new EventEmitter();

	public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

	loaded: boolean = false;
	dataSaving: boolean;

	carriers: KeyValueObject[] = [];

	carrierCompanyTrackModel: CarrierCompanyTrackModel = null;

	files: UploadFile[] = [];

	constructor(
		public dialog: DialogRef,
		private lookupService: LookupService,
		private carriersService: CarriersService,
		private requestsService: RequestsService,
		private attachmentsService: AttachmentsService
	) { }

	ngOnInit(): void {
		const carriers$ = this.lookupService.getData("carriers", null);
		const carrierCompanyTrackModel$ = this.requestsService.getCarrierCompanyTrack(this.requestId);

		forkJoin([carriers$, carrierCompanyTrackModel$])
		.subscribe(([carriers, carrierCompanyTrackModel]) => {
			this.carriers = carriers;
			this.carrierCompanyTrackModel = carrierCompanyTrackModel == null 
				? new CarrierCompanyTrackModel()
				: carrierCompanyTrackModel; 

			if (carriers.length > 0) {
				this.carrierCompanyTrackModel.carrierId = carriers[0].id;
			}

			this.loaded = true;
		});
	}

	apply(): void {
		this.dataSaving = true;

		this.requestsService.updateCarrierCompanyTrack(this.carrierCompanyTrackModel).subscribe(() => {
			if (this.files.length > 0) {
				const uploadModel = new UploadAttachmentsModel({
					requestId: this.requestId,
					activityId: this.activityId,
					attachments: this.files,
					attachmentTypeId: AttachmentType.productInvoice
				});

				this.attachmentsService.upload(uploadModel).subscribe((x) => {
					this.onContinueEvent.emit();
					this.dataSaving = false;
					this.dialog.close();
				});
			}
			else {
				this.onContinueEvent.emit();
				this.dataSaving = false;
				this.dialog.close();
			}
		});
	}

	cancel(): void {
		if (this.dialog)
			this.dialog.close();
	}

	onUploadFilesAdded(files: UploadFile[] = []) {
		this.files = files;
	}

	get cardHeight(): number {
		return window.innerHeight - 500;
	}

	get canApply(): boolean {
		return !this.isEmpty(this.carrierCompanyTrackModel.trackNumber);
	}

	isEmpty(value: string): boolean {
		return value == null || value.trim() == '';
	}
}
